// extracted by mini-css-extract-plugin
module.exports = {"C_section3":"Section3_C_section3__l3kT6"};